import { BusinessState, CachedState, MemoProductSizes } from '../models';

export function cachedBusiness(
  state: BusinessState,
  change: CachedState,
): BusinessState {
  return {
    ...state,
    cached: change,
  };
}

export function cachedProductDataBusiness(
  state: BusinessState,
  change: { [index: string]: MemoProductSizes },
): BusinessState {
  return cachedBusiness(state, {
    ...state.cached,
    memoProductSizes: {
      ...state.cached.memoProductSizes,
      ...change,
    },
  });
}
